//interfaces

import { PageSizeType } from "@/app/model/types";
import { IProduct } from "../product/type";

export interface ISummaryOrder {
  year: number;
  month: number;
  statuses: string;
}

export interface IReportProduct {
  vendorId: string;
  brandName: string;
  figureNumber: string;
  modelName: string;
  figureWidth: string;
  figureDiameter: number;
  discOffset: string;
  drilling: number;
  diameterOfCenteringHoles: string;
  diameterWheelHub: string;
  colorName: string;
  fitting: string;
  performance: string;
  code: string;
  dealerOrderItems: ReportDealerInfoType[];
  remainsQuantity: number;
  productionPlanQuantity: number;
  width?: string;
  diameter?: number;
}

export type ReportChangeBodyType = {
  orderItemDraftId: string;
  quantity: number;
};
export type ReportChangePreQuantityBodyType = {
  vendorId: string;
  mainDealerId: string;
  quantity: number;
};

export interface ReportSliceState {
  error: null | string | unknown;
  isLoading: boolean;
  isReportRefreshing: boolean;
  summaryOrderList: ISummaryOrder[];
  summaryOrderListForFilter: ISummaryOrder[];
  currentReportsState: IReportsState | null;
  reportProductList: IReportProduct[];
  totalAmount: number;
  totalCount: number;
  filters: ReportFilterType | [];
  selectedDates: string[] | undefined;
  sortRules: StateSortType;
  searchCode: null | string;
  orderSearchCode: null | string;
  totalItemsCount: number;
  isFilterLoading: boolean;
  selectedOrderFilters?: Partial<{ createdDate: string[] }>;
  excludeItems: (keyof IReportProduct)[];
  reportHideColumnsList: (keyof IReportProduct)[];
  selectedFilters: Partial<Record<keyof IProduct, string[]>>;
  pageSize: PageSizeType;
  currentOrder: null | ISummaryOrder;
  loadingExcel: boolean;
  dataToFetch: ReportChangeBodyType[];
  dataToFetchPreQuantity: ReportChangePreQuantityBodyType[];
  selectedProductId: string | null;
  sortedIds: string[];

  isGenerateReport: boolean;
  errorReport: string;
  reportName: string;
}

export interface IReportsState {
  hasRequestedReport: boolean;
  hasProductionPlanReport: boolean;
  hasConfirmedReport: boolean;
  hasFinalReport: boolean;
  hasDraft: boolean;
  canCreateDraft: boolean;
  hasProlongationDealers: boolean;
}

//enums

export enum ReportKeysEnum {
  vendorId = "ИД",
  modelName = "Дизайн",
  code = "Артикул",
  brandName = "Серия",
  figureNumber = "Чертеж",
  figureWidth = "Обод",
  figureDiameter = "Диск",
  discOffset = "ET",
  drilling = "LZ",
  diameterOfCenteringHoles = "PCD",
  diameterWheelHub = "DIA",
  colorName = "Покраска",
  fitting = "№ сборки",
  performance = "Исполнение",
  dealerOrderItems = "Дилер",
  remainsQuantity = "Остатки",
  productionPlanQuantity = "Будет произведено",
}

export enum ReportFilterKeysEnum {
  modelName = "Модель",
  figureNumber = "Чертеж",
}

export enum ReportHeadersEnum {
  month = "Группы отчетов",
  year = "Дата",
  statuses = "Статус",
}

export enum OrderStatusesEnum {
  //не исп
  draft = "Черновик",
  review = "На рассмотрении",
  confirmed = "Подтвержден",
  canceled = "Отменен",
  partiallyConfirmed = "Частично подтвержден",
  production = "В работе",
  partiallyShipped = "Частично отгружен",
  shipped = "Отгружен",
}

export enum SortValuesEnum {
  orderNumber,
  createdDate,
  reportStatusName,
}

export enum DealerKeysEnum {
  dealerId = "Ид",
  dealerName = "Название дилера ",
  dealerShortName = "Название дилера",
  dealerOrderCreated = "Дата создания заявки",
  requestedQuantity = "Заказано",
  shippedQuantity = "Отгружено",
  reservedQuantity = "Резерв",
  ensuredQuantity = "К распределению",
  quantity = "Количество",
  orderItemDraftId = "ИД позиции",
}

// types

export interface ReportDealerFilialInfoType {
  //не исп
  dealerId: string;
  dealerName: string;
  dealerShortName: string;
  dealerOrderCreated?: string;
  requestedQuantity?: number;
  reservedQuantity?: number;
  shippedQuantity?: number;
  ensuredQuantity?: number;
  quantity?: number;
  orderItemDraftId?: string;
  // requiredAmountForDistribution: number;
  mainDealerId: string | null;
}
export interface ReportDealerInfoType {
  dealerId: string;
  dealerName: string;
  dealerShortName: string;
  dealerOrderCreated?: string;
  requestedQuantity?: number;
  reservedQuantity?: number;
  shippedQuantity?: number;
  ensuredQuantity?: number;
  quantity?: number;
  orderItemDraftId?: string;
  preQuantityByDealerVendor?: number;
  mainDealerId: string | null;
  branches?: ReportDealerInfoType[];
  canDistribute: boolean;
  disabled: boolean;
}

export type ReportStatusType =
  | "needPlan"
  | "hasPlanNeedDistribution"
  | "hasDraft"
  | "distributed"
  | "fact";

export type ReportType = "requested" | "plan" | "confirmed" | "final";
export type StateSortType = {
  type: "desc" | "asc";
  field: keyof typeof SortValuesEnum;
};

export type ReportFilterItemType = Partial<
  Record<keyof IReportProduct, string[]>
> & {
  createdDate?: string[];
};

export type FilterFieldsType = {
  //не исп
  createdDate?: string[];
};

export type ReportFilterType = [
  {
    type: string;
    fields: ReportFilterItemType;
  },
];

export type ReportSearchFilterType = [
  {
    type: "like";
    fields: {
      findReportNumber?: string[];
      findCode?: string[];
    };
  },
];

export type ReportStateBodyType = {
  month: number;
  year: number;
};

export type ReportFiltersBodyType = {
  //не исп
  filters: ReportSearchFilterType | [];
};

export type ReportBodyType = {
  pagination: {
    pageSize: number;
    pageNumber: number;
  };
  order?: {
    type: "asc" | "desc";
    field: string;
  };

  filters: ReportFilterType | ReportSearchFilterType | [];
  dealerId?: string;
  year: number;
  month: number;
};

export type DraftReportBodyType = {
  pagination: {
    pageSize: number;
    pageNumber: number;
  };
  year?: number;
  month?: number;
  filters: ReportFilterType | ReportSearchFilterType | [];
};
export type ReportRequestBodyType = {
  year: number;
  month: number;
  reportType: number;
  dmsReportName: number;
};
export type DraftReqBodyType = {
  orderItemDraftId: string;
  quantity: number;
};

export type DraftItemsReqBodyType = {
  items: DraftReqBodyType[];
};

// Типы для ответов API
export interface ReportStateResponse extends IReportsState {}

export interface ReportResponse {
  items: IReportProduct[];
  totalCount: number;
}

export interface SummaryOrdersResponse {
  items: ISummaryOrder[];
}
export enum StateEnum {
  Started = "Started",
  Stopped = "Stopped",
  Cancelled = "Cancelled",
  Failed = "Failed",
  Completed = "Completed",
  Unknown = "Unknown",
}
